import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AuthLoginInfos} from '../Model/login-info';
import {Observable} from 'rxjs';
import {JwtResponse} from '../Model/jwt-response';
import {SignupInfo} from '../Model/signup-info';
import {TokenStorageService} from './token-storage.service';
import {JwtHelperService} from '@auth0/angular-jwt';
import {environment} from '../../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private loginUrl = environment.baseUrl + 'auth/signin';
  private signupUrl = environment.baseUrl + 'auth/signup';
  jwtHelper = new JwtHelperService();

  constructor(private http: HttpClient, private tokenService: TokenStorageService) {
  }

  attemptAuth(credentials: AuthLoginInfos): Observable<JwtResponse> {
    return this.http.post<JwtResponse>(this.loginUrl, credentials, httpOptions);
  }

  signUp(info: SignupInfo): Observable<string> {
    return this.http.post<string>(this.signupUrl, info, httpOptions);
  }

  public isAuthenticated(): boolean {
    return sessionStorage.getItem('AuthToken') != null && this.isValidToken();
  }

  public isValidToken(): boolean {
    const token: string = this.tokenService.getToken();
    return token != null && !this.jwtHelper.isTokenExpired(token);
  }
}
